import React from "react";
import { makeStyles, Theme, createStyles, Backdrop } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: 1800,
      color: "var(--theme-color)",
    },
    flex: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    flexfirst: {
      marginBottom: "8px",
    },
    text: {
      fontFamily: "var(--font-medium)",
      color: "white",
      fontSizes: "18px",
    },
  })
);

const Waiter = (props: any) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Backdrop open={props.backdropOpen} className={classes.backdrop}>
        <div className={classes.flex}>
          <div className={classes.flexfirst}>
            <img
              src="/logo192.png"
              alt="Waiting..."
              width="100px"
              height="100px"
            />
          </div>
          <div className={classes.text}>{props.text}</div>
        </div>
      </Backdrop>
    </React.Fragment>
  );
};

export default Waiter;
